import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewShopAll from '@/views/view-shop-all';

import '../../styles/pages/shop-all.scss';

whenDomReady(() => {
    new ViewShopAll({el: $('#MainContent')});
});